import { useState } from "react";
import type { Match } from "@/mocks/matches";
import MatchCard from "@/components/base/MatchCard";
import SectionHeader from "@/components/base/SectionHeader";

interface MatchSectionProps {
  matches: Match[];
}

const tabs = [
  { key: "all", label: "全部" },
  { key: "live", label: "直播中" },
  { key: "upcoming", label: "即将开始" },
  { key: "finished", label: "已结束" },
] as const;

type TabKey = (typeof tabs)[number]["key"];

export default function MatchSection({ matches }: MatchSectionProps) {
  const [tab, setTab] = useState<TabKey>("all");

  const filtered =
    tab === "all" ? matches : matches.filter((m) => m.status === tab);

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <SectionHeader
          title="今日赛程与直播"
          subtitle="实时比分、对阵信息与开赛时间一目了然"
          moreTo="/live"
          moreLabel="全部直播"
          icon={<i className="ri-calendar-event-line text-lg" />}
        />

        <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100 mb-6">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                tab === t.key
                  ? "bg-primary-500 text-white"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="py-16 text-center bg-background-100 rounded-lg border border-background-200">
            <i className="ri-emotion-normal-line text-4xl text-foreground-300" />
            <p className="mt-3 text-sm text-foreground-500">
              当前分类下暂无赛事，换个筛选条件试试
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
            {filtered.map((m) => (
              <MatchCard key={m.id} match={m} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}